module.exports = __webpack_public_path__ + "static/media/tharu-tika-fnl.8410480b.mp4";